var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("h3", [_vm._v("客户信息")]),
              _c(
                "el-form",
                {
                  ref: "dataForm",
                  attrs: {
                    model: _vm.childData,
                    rules: _vm.rules,
                    "label-position": "right",
                    "label-width": "90px"
                  }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户名称", prop: "attractName" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "180px" },
                            model: {
                              value: _vm.childData.attractName,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "attractName", $$v)
                              },
                              expression: "childData.attractName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "所属行业", prop: "industry" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "180px" },
                              attrs: {
                                filterable: "",
                                placeholder: "请选择所属行业"
                              },
                              model: {
                                value: _vm.childData.industry,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "industry", $$v)
                                },
                                expression: "childData.industry"
                              }
                            },
                            _vm._l(_vm.businessOption, function(item) {
                              return _c("el-option", {
                                key: item.dicValue,
                                attrs: {
                                  label: item.dicName,
                                  value: item.dicValue
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户状态", prop: "attractStatus" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "180px" },
                              attrs: {
                                placeholder: "请选择客户状态",
                                clearable: ""
                              },
                              model: {
                                value: _vm.childData.attractStatus,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "attractStatus", $$v)
                                },
                                expression: "childData.attractStatus"
                              }
                            },
                            _vm._l(_vm.customStatusOption, function(item) {
                              return _c("el-option", {
                                key: item.dicValue,
                                attrs: {
                                  label: item.dicName,
                                  value: item.dicValue
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系人" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "180px" },
                            model: {
                              value: _vm.childData.linkman,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "linkman", $$v)
                              },
                              expression: "childData.linkman"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系电话" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "180px" },
                            model: {
                              value: _vm.childData.linkmanPhone,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "linkmanPhone", $$v)
                              },
                              expression: "childData.linkmanPhone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "来访时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "180px" },
                            attrs: {
                              type: "date",
                              placeholder: "请选择来访时间",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.childData.attractDate,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "attractDate", $$v)
                              },
                              expression: "childData.attractDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "来源渠道" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "180px" },
                              attrs: {
                                placeholder: "请选择来源渠道",
                                clearable: ""
                              },
                              model: {
                                value: _vm.childData.channelType,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "channelType", $$v)
                                },
                                expression: "childData.channelType"
                              }
                            },
                            _vm._l(_vm.sourceStatusOption, function(item) {
                              return _c("el-option", {
                                key: item.dicValue,
                                attrs: {
                                  label: item.dicName,
                                  value: item.dicValue
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "销售阶段" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "180px" },
                              attrs: {
                                placeholder: "请选择销售阶段",
                                clearable: ""
                              },
                              model: {
                                value: _vm.childData.salesStatus,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "salesStatus", $$v)
                                },
                                expression: "childData.salesStatus"
                              }
                            },
                            _vm._l(_vm.saleStatusOption, function(item) {
                              return _c("el-option", {
                                key: item.dicValue,
                                attrs: {
                                  label: item.dicName,
                                  value: item.dicValue
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户需求" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "470px" },
                            model: {
                              value: _vm.childData.attractDemand,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "attractDemand", $$v)
                              },
                              expression: "childData.attractDemand"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.childData.attractStatus == 3
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "流失时间", prop: "loseDate" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  type: "date",
                                  placeholder: "请选择流失时间",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.childData.loseDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.childData, "loseDate", $$v)
                                  },
                                  expression: "childData.loseDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.childData.attractStatus == 3
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "流失原因", prop: "loseReason" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "180px" },
                                  attrs: {
                                    placeholder: "请选择流失原因",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.childData.loseReason,
                                    callback: function($$v) {
                                      _vm.$set(_vm.childData, "loseReason", $$v)
                                    },
                                    expression: "childData.loseReason"
                                  }
                                },
                                _vm._l(_vm.lossStatusOption, function(item) {
                                  return _c("el-option", {
                                    key: item.dicValue,
                                    attrs: {
                                      label: item.dicName,
                                      value: item.dicValue
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("table.remark") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "470px" },
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 2, maxRows: 2 }
                            },
                            model: {
                              value: _vm.childData.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "remark", $$v)
                              },
                              expression: "childData.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("h3", [_vm._v("意向房源")]),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "560px" },
                    attrs: { icon: "el-icon-circle-plus-outline" },
                    on: { click: _vm.addHouse }
                  },
                  [_vm._v("添加")]
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  overflow: "auto",
                  height: "450px",
                  "margin-bottom": "10px",
                  "margin-top": "10px"
                }
              },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.childData.detailList,
                      border: "",
                      stripe: "",
                      fit: "",
                      "highlight-current-row": ""
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { align: "center", label: "小区名称" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.areaName))])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "楼栋/房号" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.houseCode))])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "面积" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.houseArea) + "㎡")
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "房间状态" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.houseStatusName))
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "空置时间" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.opDate))])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "100",
                        align: "center",
                        label: _vm.$t("table.actions"),
                        "class-name": "small-padding fixed-width"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    plain: "",
                                    icon: "el-icon-delete",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleDelete(scope.row.houseId)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("chooseHouseTree", {
            attrs: { "show-dialog": _vm.dialogFormVisible },
            on: {
              handCancle: _vm.handhouseCancle,
              sendHouseData: _vm.receiveHouseData
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }